module.exports = __webpack_public_path__ + "media/images/map/map-marker-active-4accc5be88335111a139eac59113fc8f.png";